import React from 'react';
import {createRoot} from "react-dom/client";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const root = createRoot(document.getElementById("root"));
const stripePromise = loadStripe("pk_live_51QHwwqH0z8KFU9JQYSZt2d4c9PttrixrmuNo1rOgU2jKNcTpL6vGkH7zAMyFV5B01QDmMVdTtmyGL5zejW18BNck001X4LzXb9"); // Replace with your publishable key
root.render(
  <BrowserRouter>
  <Elements stripe={stripePromise}>
    <App />
    </Elements>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
